export const getData = (state) => state.data

export default {}
